import { useEffect, useRef, useState } from 'react';

const hasFiles = (event: DragEvent) =>
  event.dataTransfer ? Array.from(event.dataTransfer.types).includes('Files') : false;

export const useFileDragState = (): boolean => {
  const [isDragging, setIsDragging] = useState(false);
  const counter = useRef(0);

  useEffect(() => {
    const onDragEnter = (event: DragEvent) => {
      if (!hasFiles(event)) return;
      counter.current += 1;
      if (counter.current === 1) {
        setIsDragging(true);
      }
    };

    const onDragLeave = (event: DragEvent) => {
      if (!hasFiles(event)) return;
      counter.current = Math.max(0, counter.current - 1);
      if (counter.current === 0) {
        setIsDragging(false);
      }
    };

    const onDrop = () => {
      counter.current = 0;
      setIsDragging(false);
    };

    window.addEventListener('dragenter', onDragEnter);
    window.addEventListener('dragleave', onDragLeave);
    window.addEventListener('drop', onDrop);

    return () => {
      window.removeEventListener('dragenter', onDragEnter);
      window.removeEventListener('dragleave', onDragLeave);
      window.removeEventListener('drop', onDrop);
    };
  }, []);

  return isDragging;
};

export default useFileDragState;
